import TabPanel from "../Reusable/Tab";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import EditRunsheet from "./EditRunsheet";

const SwitchTab = (props: any) => {
  const {
    handleEdit,
    isLoading,
    data,
    handleAttachConsignment,
    handlePrint,
    handleToggleMarkAsDone,
    handleRemove,
    isRemoved,
    isPrintLoading,
    handlecheckConsignments,
    handleToggleMarkAsUnDone,
    gridData,
    handleStatusChange,
    defaultValue,
    isMarkAsDoneLoading,
    id,
    setISactive,
    isactive,
  } = props;

  return (
    <>
      <>
        <TabPanel
          tabTitle={["Update", "Documents"]}
          tabPanels={[
            <>
              <EditRunsheet
                handleEdit={handleEdit}
                isLoading={isLoading}
                data={data}
                handleAttachConsignment={handleAttachConsignment}
                handlePrint={handlePrint}
                handleToggleMarkAsDone={handleToggleMarkAsDone}
                handleRemove={handleRemove}
                isRemoved={isRemoved}
                isPrintLoading={isPrintLoading}
                handlecheckConsignments={handlecheckConsignments}
                gridData={gridData}
                handleStatusChange={handleStatusChange}
                defaultValue={defaultValue}
                isMarkAsDoneLoading={isMarkAsDoneLoading}
                handleToggleMarkAsUnDone={handleToggleMarkAsUnDone}
                id={id}
                setISactive={setISactive}
                isactive={isactive}
              />
            </>,
            <>
              <FileUpload object_id={id} />
            </>,
          ]}
        />
      </>
    </>
  );
};

export default SwitchTab;
